"use client"

import { Link } from "react-router-dom"
import { SiDoordash, SiUbereats } from "react-icons/si"

const DeliveryModal = ({ isOpen, onClose, pickupPath = "/menu" }) => {
  if (!isOpen) return null

  const DOORDASH_URL = process.env.REACT_APP_DOORDASH_URL || ""
  const UBER_EATS_URL = process.env.REACT_APP_UBER_EATS_URL || ""
  const hasDoorDash = Boolean(DOORDASH_URL)
  const hasUberEats = Boolean(UBER_EATS_URL)

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4" onClick={onClose}>
      <div
        className="w-full max-w-lg bg-white rounded-xl shadow-xl p-6 sm:p-8 text-black"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-2xl font-bold mb-3">Pickup or Delivery?</h3>
        <p className="text-base mb-6">
          This menu is for pickup only. For delivery, please order through DoorDash or Uber Eats.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          {hasDoorDash ? (
            <a
              href={DOORDASH_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Order delivery on DoorDash"
              className="flex-1 h-12 flex items-center justify-center rounded-md bg-black text-white hover:bg-gray-800 transition"
            >
              <SiDoordash className="text-3xl" />
            </a>
          ) : (
            <button
              type="button"
              disabled
              aria-label="DoorDash link needed"
              className="flex-1 h-12 flex items-center justify-center rounded-md bg-gray-400 text-white cursor-not-allowed"
            >
              <SiDoordash className="text-3xl" />
            </button>
          )}
          {hasUberEats ? (
            <a
              href={UBER_EATS_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Order delivery on Uber Eats"
              className="flex-1 h-12 flex items-center justify-center rounded-md bg-black text-white hover:bg-gray-800 transition"
            >
              <SiUbereats className="text-3xl" />
            </a>
          ) : (
            <button
              type="button"
              disabled
              aria-label="Uber Eats link needed"
              className="flex-1 h-12 flex items-center justify-center rounded-md bg-gray-400 text-white cursor-not-allowed"
            >
              <SiUbereats className="text-3xl" />
            </button>
          )}
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to={pickupPath}
            className="flex-1 px-4 py-3 bg-black text-white text-base font-medium rounded-md text-center hover:bg-gray-800 transition"
            onClick={onClose}
          >
            Continue to Pickup Menu
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 px-4 py-3 border border-black text-black text-base font-medium rounded-md hover:bg-black hover:text-white transition"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeliveryModal
